export const environment = {
  production: false,
  clientId: 'bdd75656-6b4a-4de6-a6db-c6a0329f9714',
  scopes: 'api://bdd75656-6b4a-4de6-a6db-c6a0329f9714/User.Read',
  tenantId: '8def9a7d-e13f-475b-bd57-f27619723591',
  redirectUri: 'https://portal-vivest-center-dev.vivest.com.br/login',
  apiPrefix: '/apis/api-portal-vivest-center-dev',
  baseUrl: 'https://homologacao.vivest.com.br',
  secret: '9ABD1328679B76D1E0781A231CFD8F69BF3C6A96119B3F2F0116636FE8B35C9E',
  ocpapimsubscriptionkey: 'a73b6d8808fe4cbf983d1af07e642ef2',
  ambiente: 'desenvolvimento'
};
